<template>
  <label class="form-check form-switch form-switch-2" v-if="isShow()">
    <input class="form-check-input" type="checkbox" v-model="fields.action_link" @change="onClick">
    <span class="form-check-label">Открывать при клике</span>
  </label>
</template>

<script>
import {defineComponent, watch, reactive} from "vue"
import Helper from "@/services/Helper"

export default defineComponent({
  name: "ActionLink",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    const fields = reactive({
      action_link: false,
      type_id: 0,
    })

    watch(() => props.payload, (val) => {
      if (Helper.isObject(val)) {
        updateFields(val)
      }
    }, {
      immediate: true,
    })

    function isShow() {
      return Helper.inArray([fields.type_id], [7])
    }

    function updateFields(query) {
      fields.action_link = query.action_link
      fields.type_id = query.type_id
    }

    function pushEvent(val) {
      emit("onChange", val)
    }

    function onClick() {
      pushEvent({
        action_link: fields.action_link,
      })
    }

    return {
      onClick,
      fields,
      isShow,
    }
  }
})
</script>
